import { render, staticRenderFns } from "./data-source-field.component.vue?vue&type=template&id=6dcb9203&scoped=true&"
import script from "./data-source-field.component.vue?vue&type=script&lang=ts&"
export * from "./data-source-field.component.vue?vue&type=script&lang=ts&"
import style0 from "./data-source-field.component.vue?vue&type=style&index=0&id=6dcb9203&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcb9203",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VIcon,VSelect})
